import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => [
    { value: null, text: $t('data.staff.(Seleccionar)', '(Seleccionar)'), disabled: true },
    { value: "1-5", text: "1 - 5" },
    { value: "6-10", text: "6 - 10" },
    { value: "11-20", text: "11 - 20" },
    { value: "21-50", text: "21 - 50" },
    { value: "51-100", text: "51 - 100" },
    { value: "100+", text: "> 100" }
];
